import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../../CommonData/Locals/en.json';
import svTranslations from '../../CommonData/Locals/sv.json';
import enAdminTranslations from '../../CommonData/Locals/Admin/en.json';
import svAdminTranslations from '../../CommonData/Locals/Admin/sv.json';
import { getPortalAlias } from '../Services/common';
import { globalProperties } from '../Services/global';
import { capitalizeFirstLetter } from './stringUtils';

type TranslationObject = Record<string, unknown>;

ensureI18nInitialized();

export default i18n;

//to avoid issues with shallow spread of nested translation objects, we need to do a deep merge of the default translations
//otherwise one key with nested keys (e.g. "TIMEREPORT") would be completely overwritten by another translation with the same key, causing missing translations in the UI
//potential remaing issue: the same key might exist in mulitple translation files and will be overwritten by the last one
//TODO: make sure we use different top level keys in every translation file to avoid these issues in the future
//Maybe TODO: do not include admins for the outside and vice versa? Two different i18n instances?
function mergeTranslationObjects(...sources: TranslationObject[]) {
	const result: TranslationObject = {};

	for (const source of sources) {
		for (const [key, value] of Object.entries(source)) {
			const currentValue = result[key];
			if (isPlainTranslationObject(currentValue) && isPlainTranslationObject(value)) {
				result[key] = mergeTranslationObjects(currentValue, value);
				continue;
			}

			result[key] = value;
		}
	}

	return result;
}

function isPlainTranslationObject(value: unknown): value is TranslationObject {
	return !!value && typeof value === 'object' && !Array.isArray(value);
}

export function ensureI18nInitialized() {
	if (i18n.isInitialized) {
		return;
	}

	i18n.use(initReactI18next).init({
		resources: {
			en: {
				translation: mergeTranslationObjects(
					enTranslations as TranslationObject,
					enAdminTranslations as TranslationObject
				),
			},
			sv: {
				translation: mergeTranslationObjects(
					svTranslations as TranslationObject,
					svAdminTranslations as TranslationObject
				),
			},
		},
		lng: 'en',
		fallbackLng: 'en',

		interpolation: {
			escapeValue: false,
		},
	});

	loadCustomerTranslations();
}

async function loadCustomerTranslations() {
	const portalAlias = getPortalAlias();
	console.log('loading customer translations for', portalAlias);

	try {
		const translations = await import(`../../Customers/${globalProperties.portalAlias}/Data/Locales/en.json`);
		i18n.addResourceBundle('en', 'translation', translations, true, true);
	} catch (error) {
		//console.error('Error loading customer translations:', error);
	}

	try {
		const translations = await import(`../../Customers/${globalProperties.portalAlias}/Data/Locales/sv.json`);
		i18n.addResourceBundle('sv', 'translation', translations, true, true);
	} catch (error) {
		//console.error('Error loading customer translations:', error);
	}

	// legacy customer translations
	const normalizedPortalAlias = capitalizeFirstLetter(globalProperties.portalAlias);
	try {
		const translations = await import(`../../../../FrontEnd/i18n/customer/${normalizedPortalAlias}/en.json`);
		i18n.addResourceBundle('en', 'translation', translations, true, true);
	} catch (error) {
		//console.error('Error loading customer translations frontendreact:', error);
	}

	try {
		const translations = await import(`../../../../FrontEnd/i18n/customer/${normalizedPortalAlias}/sv.json`);
		i18n.addResourceBundle('sv', 'translation', translations, true, true);
	} catch (error) {
		//console.error('Error loading customer translations frontendreact:', error);
	}
}
